

import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Splash from './components/Splash';
import WhatsAppButton from './components/WhatsAppButton';
import { useState } from 'react';


function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <div className="App">
      {showSplash && <Splash onComplete={() => setShowSplash(false)} />}
      {!showSplash && (
        <>
          <Header />
          <Hero />
          <About />
          <Services />
          <Projects />
          <Contact />
          <Footer />
          <WhatsAppButton />
        </>
      )}
    </div>
  );
}

export default App;
